import { serviceClient } from '@yola/ws-sdk';

const callSiteMigration = (siteId) => {
  const client = serviceClient.get();
  return client.runSiteMigrations(siteId);
};

export default callSiteMigration;
